import React, { useCallback } from 'react'

const Input = ({ defaultValue, value, onChange, classNameParent, type, className, text, size, icon, append, invalid, iconText, smallColor, ...props }) => {

  const propInput = useCallback(() => {
    return defaultValue ? { defaultValue } : { value }
  }, [defaultValue, value])

  if (type === 'hidden')
    return (<input {...props} {...propInput()} type="hidden" className={'form-control ' + className} />)
  else
    return (<div className={classNameParent}>
      <small className={smallColor}>{text}</small>
      <div className={type === 'checkbox' ? 'form-check' : 'input-group input-group-' + size}>
        {icon || iconText ? <div className="input-group-prepend">
          <div className="input-group-text">{icon ? <i className={icon}></i> : iconText}</div>
        </div> : ''}
        {type === 'file' ? <input {...props} type="file" onChange={onChange} /> : <input {...props}  {...propInput()} onChange={onChange} type={type} className={(type === 'checkbox' ? 'form-check-input ' : 'form-control ') + className} />}
        {React.Children.toArray(append)}
        <div className="invalid-feedback">
          {invalid}
        </div>
      </div>

    </div>)
}

Input.defaultProps = {
  size: 'lg',
  classNameParent: 'col-12',
  type: 'text',
  required: false,
  append: [],
  className: '',
  onChange: () => { },
  smallColor: 'text-muted'
}

export default Input